import { render } from "./map-box.vue?vue&type=template&id=2405cf3a&scoped=true"
import script from "./map-box.vue?vue&type=script&lang=js"
export * from "./map-box.vue?vue&type=script&lang=js"

import "./map-box.vue?vue&type=style&index=0&id=2405cf3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2405cf3a"]])

export default __exports__